var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.26673 5.4803H1.7334V16.2136C1.7334 17.057 2.4234 17.747 3.26673 17.747H14.0001V16.2136H3.26673V5.4803ZM15.5334 2.41364H6.3334C5.49007 2.41364 4.80007 3.10364 4.80007 3.94697V13.147C4.80007 13.9903 5.49007 14.6803 6.3334 14.6803H15.5334C16.3767 14.6803 17.0667 13.9903 17.0667 13.147V3.94697C17.0667 3.10364 16.3767 2.41364 15.5334 2.41364ZM9.40007 11.997V5.09697L14.0001 8.54697L9.40007 11.997Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4,
    height: 18.4,
    fill: "white",
    transform: "translate(0.200195 0.88031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.fde581bbe31393de62bf02fd5141c5d2.svg";
export { ForwardRef as ReactComponent };